// extracted by mini-css-extract-plugin
export default {"wrap":"_F-z","articleImagesWrap":"aG-z","articleImage":"bG-z","singleImage":"cG-z"};